import React from 'react';
import type { StylesConfig } from 'react-select';
import Select from 'react-select';
import { DOC_TYPES } from '../../routes/Checkout/store/constants/tourists';
import { isChild } from './utils';
import { NATIONALITY_CONSTANTS } from '../../constants';
import { countriesWhereRuDocAllowed } from './contstants';

interface Props {
  country: string;
  /**
   * заменить string на DocType, когда попадет в прод
   * @see https://github.com/LevelTravel/leveltravel/blob/b11283d1a16356d4105ac1c5de7c59d0fa6285c2/client/lt-modules/src/routes/Package/containers/Tourists/types.ts#L11
   */
  onChange: (docType: string) => void;
  age?: number | null;
  value?: string;
  touristCitizenship: number;
}

class DocumentType extends React.PureComponent<Props> {
  static SELECT_STYLE: StylesConfig = {
    control: () => ({ display: 'flex' }),
    menu: (base) => ({
      ...base,
      width: 'auto',
      marginTop: 0,
      zIndex: 999999,
    }),
    option: (base) => ({ ...base, whiteSpace: 'nowrap', fontSize: 15 }),
    singleValue: (base, state) => ({
      fontWeight: 'bold',
      cursor: state.isDisabled ? 'default' : 'pointer',
    }),
    valueContainer: () => ({
      display: 'flex',
      alignItems: 'center',
      color: '#17181a',
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    dropdownIndicator: (base, state) =>
      state.isDisabled
        ? { display: 'none' }
        : { ...base, padding: 0, paddingTop: '5px' },
  };

  static startCase = (str) => str[0].toUpperCase() + str.substring(1);

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { value, onChange } = this.props;
    if (!value) {
      const [defaultType] = this.docTypes;
      onChange(defaultType.id);
    }
  }

  componentDidUpdate() {
    if (!this.selectedOption) {
      const [selected] = this.options;
      this.handleChange(selected);
    }
  }

  handleChange(event) {
    const { value } = event;
    const { onChange } = this.props;
    onChange(value);
  }

  get docTypes() {
    return Object.keys(DOC_TYPES)
      .filter((type) => this.isDocTypeEnabled(type))
      .map((type) => DOC_TYPES[type]);
  }

  get options() {
    return this.docTypes.map(({ id, name }) => ({
      value: id,
      label: DocumentType.startCase(name),
    }));
  }

  get selectedOption() {
    const { value } = this.props;
    return this.options.find((option) => option.value === value);
  }

  isDocTypeEnabled(type) {
    const { age, country, touristCitizenship } = this.props;
    const hasPassport = !isChild(age) || (age && age >= 14);
    const isRuCitizen = touristCitizenship === NATIONALITY_CONSTANTS.RU;
    const ruDocsAllowed =
      isRuCitizen && countriesWhereRuDocAllowed.indexOf(country) !== -1;

    switch (type) {
      case DOC_TYPES.internal_passport.id:
        return ruDocsAllowed && hasPassport;
      case DOC_TYPES.birth_certificate.id:
        return ruDocsAllowed && isChild(age);
      case DOC_TYPES.international_passport.id:
        return !(isRuCitizen && country === 'RU');
      default:
        return false;
    }
  }

  render() {
    const { options } = this;
    return (
      <Select
        className="tourist-document-type"
        styles={DocumentType.SELECT_STYLE}
        value={this.selectedOption}
        options={options}
        onChange={this.handleChange}
        isDisabled={options.length <= 1}
        isSearchable={false}
      />
    );
  }
}

export default DocumentType;
